import React, { FC } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Dialog } from 'components/Dialog'
import { Stack } from 'components/Stack'
import { Heading } from 'components/Heading'
import { Text } from 'components/Text'
import { Button } from 'components/Button'
import { useTranslation } from 'react-i18next'
import { useDeleteCustomLayer } from 'services/custom-layer'

export const DeleteCustomLayerDialog: FC = () => {
  const { t } = useTranslation()
  const { layerId } = useParams()
  const navigate = useNavigate()
  const [deleteCustomlayer, { status }] = useDeleteCustomLayer(layerId)

  const onDelete = () => deleteCustomlayer(undefined, { onSuccess: () => onClose() })
  const onClose = () => navigate('/datasets')

  return (
    <Dialog aria-label={t('custom_layer_dialog.delete.title')} isOpen={true} onClose={onClose}>
      <Stack>
        <div>
          <Heading size="secondary">{t('custom_layer_dialog.delete.title')}</Heading>
          <Text>{t('custom_layer_dialog.delete.subtitle')}</Text>
        </div>
        <Stack space="medium">
          <Button onClick={onClose} variant="secondary" full>
            {t('custom_layer_dialog.delete.cancel')}
          </Button>
          <Button onClick={onDelete} variant="danger" full loading={status === 'loading'}>
            {t('custom_layer_dialog.delete.cta')}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  )
}

DeleteCustomLayerDialog.displayName = 'DeleteCustomLayerDialog'
